import { Navbar } from "@vionixasia/shared-components";
import { Footer } from "../layout/Footer";
import { Outlet, useLocation } from "react-router-dom";

// `children` lets a route outside the nested Layout group still wear the site
// shell (StartlistRoute uses it for events without their own theme).
export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  // Don't show navbar/footer on Login page
  const showNavAndFooter = pathname !== "/Login";

  return (
    /* The shell states its own background instead of inheriting the body's.
       Without this it showed whatever <body> happened to be — white normally,
       but dark under a dark-mode browser, which surfaced as a black bar in the
       pt-12 strip above the hero that no child element paints over. */
    <div className="flex flex-col w-full min-h-screen bg-white">
      {/* Navbar */}
      {showNavAndFooter && (
        <Navbar appName="TIMING" menuItems={[]} hideUserName={true} />
      )}

      {/* Main content - add padding-top for pages other than home so content isn't hidden behind navbar */}
      <main className={`flex-1 w-full ${pathname !== '/' ? 'pt-12' : ''}`}>
        {children ?? <Outlet />}
      </main>

      {/* Footer */}
      {showNavAndFooter && (
        <div className="w-full flex-shrink-0">
          <Footer />
        </div>
      )}
    </div>
  );
};
